import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal, Spinner } from "react-bootstrap";
import {
  addCenterBlog,
  getCenterBlogCategories,
  getCenterBlogs,
} from "../../../store/actions/centerActions/blogAction";

// Status word + colour for a blog's approval state.
const statusInfo = (s) => {
  if (Number(s) === 1) return { label: "Approved", color: "#157347" };
  if (Number(s) === 2) return { label: "Rejected", color: "#c0392b" };
  return { label: "Pending Approval", color: "#b8860b" };
};

export default function CenterBlog() {
  const dispatch = useDispatch();
  const [access, setAccess] = useState(true);
  const [categories, setCategories] = useState([]);
  const [blogs, setBlogs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const empty = {
    category_id: "",
    title: "",
    short_description: "",
    description: "",
    video_url: "",
  };
  const [form, setForm] = useState(empty);
  const [file, setFile] = useState(null);

  const loadBlogs = async () => {
    setLoading(true);
    const res = await dispatch(getCenterBlogs(1));
    setBlogs(res && res.data ? res.data : []);
    setLoading(false);
  };

  useEffect(() => {
    dispatch(getCenterBlogCategories()).then((d) => {
      setAccess(!!d?.access);
      setCategories(d?.categories || []);
    });
    loadBlogs();
  }, []);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    if (file) fd.append("file", file);
    const res = await dispatch(addCenterBlog(fd));
    setSubmitting(false);
    if (res && res.status === "success") {
      setShow(false);
      setForm(empty);
      setFile(null);
      loadBlogs();
    }
  };

  return (
    <div className="mid-content-box">
      <div
        className="d-flex align-items-center justify-content-between flex-wrap"
        style={{ margin: "10px 0 18px" }}
      >
        <h4 style={{ margin: 0, fontWeight: "bold" }}>My Blogs</h4>
        {access && categories.length > 0 && (
          <button className="btn btn-comman" onClick={() => setShow(true)}>
            + Add Blog
          </button>
        )}
      </div>

      {!access ? (
        <div
          className="alert alert-warning"
          style={{ borderRadius: "8px" }}
        >
          Blog posting is not enabled for your centre. Please contact the
          council to get access.
        </div>
      ) : access && categories.length === 0 ? (
        <div className="alert alert-warning" style={{ borderRadius: "8px" }}>
          No blog categories have been allotted to your centre yet. Please
          contact the council.
        </div>
      ) : null}

      <div className="table-responsive">
        <table className="table table-separate table-head-custom">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Title</th>
              <th>Category</th>
              <th>Status</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="text-center">
                  <Spinner animation="border" role="status" size="sm" />
                </td>
              </tr>
            ) : blogs === null ? null : blogs.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center">
                  No blogs yet.
                </td>
              </tr>
            ) : (
              blogs.map((b, i) => {
                const st = statusInfo(b.approval_status);
                return (
                  <tr key={b.id}>
                    <td>{i + 1}</td>
                    <td>{b.title}</td>
                    <td>{b.category?.name || "-"}</td>
                    <td>
                      <span style={{ color: st.color, fontWeight: "bold" }}>
                        {st.label}
                      </span>
                    </td>
                    <td>
                      {Number(b.approval_status) === 2
                        ? b.reject_reason || "-"
                        : "-"}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Blog</Modal.Title>
        </Modal.Header>
        <form onSubmit={submit}>
          <Modal.Body>
            <p style={{ fontSize: 13, color: "#666" }}>
              Your blog will be published on the website once the council
              approves it.
            </p>
            <div className="boxlabel">
              <p>Category</p>
              <select
                className="form-control"
                name="category_id"
                value={form.category_id}
                onChange={onChange}
                required
              >
                <option value="">Select Category</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="boxlabel mt-2">
              <p>Title</p>
              <input
                className="form-control"
                name="title"
                value={form.title}
                onChange={onChange}
                required
              />
            </div>
            <div className="boxlabel mt-2">
              <p>Short Description</p>
              <textarea
                className="form-control"
                name="short_description"
                rows={2}
                value={form.short_description}
                onChange={onChange}
              />
            </div>
            <div className="boxlabel mt-2">
              <p>Description</p>
              <textarea
                className="form-control"
                name="description"
                rows={6}
                value={form.description}
                onChange={onChange}
                required
              />
            </div>
            <div className="boxlabel mt-2">
              <p>Video URL (optional)</p>
              <input
                className="form-control"
                name="video_url"
                value={form.video_url}
                onChange={onChange}
                placeholder="https://youtube.com/..."
              />
            </div>
            <div className="boxlabel mt-2">
              <p>Image (optional)</p>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-comman"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit for Approval"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
